import { Theme } from '@interfaces/global';
import { LeadDetails } from '@utils/backend-api/users';
import { FormLocation } from '@utils/enums';
import { LeadType } from '@utils/types';

export const GDPR_FIELD_LABEL =
  'Receive breaking news, relevant articles, and special event invites from The Information';

export interface EmailLeadCaptureProps {
  articleId?: number;
  briefingGuid?: string;
  buttonClassName?: string;
  buttonText: string;
  expandableOathButtonsClassName?: string;
  formClassName?: string;
  formLocation: FormLocation;
  gdpr?: boolean;
  gdprClassName?: string;
  gdprFormClassName?: string;
  includeSignInOption?: boolean;
  includeNewsletterOption?: boolean;
  inputClassName?: string;
  inputWrapperClassName?: string;
  isNewsletterHeader?: boolean;
  isPro?: boolean;
  isRight?: boolean;
  isVertical?: boolean;
  isVerticalMobile?: boolean;
  leadDetails?: LeadDetails;
  leadType?: LeadType;
  newsletterIds?: number[];
  oauthButtonsClassName?: string;
  oauthRedirectToOnSuccess?: string;
  redirectToOnSuccess: string;
  shareGuid?: string;
  signInOptionClass?: string;
  skipVerifyNewEmail?: boolean;
  subscribeToAllNewsletters?: boolean;
  theme?: Theme;
  toastMessageOnSuccess?: string;
  triggerNewsletterEvent?: boolean;
  unlockContent?: boolean;
  withOauth?: boolean;
  withOnlyOauthExpandable?: boolean;
  oauthWrapperClassName?: string;
}

export interface EmailLeadForm {
  email: string;
  gdprOptIn?: boolean;
}
